import {
  Avatar,
  Box,
  Card,
  CardContent,
  CardMedia,
  Divider,
  Typography,
} from "@mui/material";
import React from "react";
import RecentMatchedList from "./RecentMatchedList";
import Grid from "@mui/material/Grid2";
import RecentLoggedInList from "./RecentLogInUsers";

const recentList = [
  {
    name: "Aasha",
    description: "Software Engineer",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    matched: "Religion, Location, Skills",
  },
  {
    name: "Karthika",
    description: "Data Scientist",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    matched: "Location, Horoscope",
  },
  {
    name: "Kavya",
    description: "DevOps Engineer",
    dob: "1990-01-01",
    mobile: "+91 9876******",
    matched: "Cast, Job",
  },
];
const recentLoggedList = [
  {
    name: "Kodeswari",
    description: "HR Manager",
    dob: "1990-01-01",
    mobile: "+91 9876******",
  },
  {
    name: "Lavanya",
    description: "Project Manager",
    dob: "1990-01-01",
    mobile: "+91 9876******",
  },
  {
    name: "Nainika",
    description: "UX Designer",
    dob: "1990-01-01",
    mobile: "+91 9876******",
  },
];

const EmployeeDashboard = () => {
  return (
    <Grid container spacing={2}>
      <Grid size={{ lg: 4, md: 6, sm: 12, xs: 12 }}>
        <Typography
          fontSize={14}
          textTransform={"uppercase"}
          fontWeight={500}
          gutterBottom
        >
          Assoiciate Customer
        </Typography>
        <Card sx={{ maxWidth: 345 }}>
          <CardMedia
            component="img"
            alt="green iguana"
            height={130}
            sx={{ objectFit: "contain", backgroundColor: "#f5f5f5" }}
            image={require("../../assets/img/profiles/p5.jpg")}
          />
          <CardContent>
            <Typography gutterBottom variant="h5" component="div">
              Pooja
            </Typography>
            <Typography variant="body2" sx={{ color: "text.secondary" }}>
              Mobile: +91 9876****** <br />
              DOB: 1990-01-01 <br />
              Religion: Hindu <br />
              Location: Hydrabad <br />
            </Typography>
          </CardContent>
        </Card>
      </Grid>
      <Grid size={{ lg: 8, md: 6, sm: 12, xs: 12 }}>
        <Typography
          fontSize={14}
          textTransform={"uppercase"}
          fontWeight={500}
          gutterBottom
        >
          Recent Matches
        </Typography>
        <RecentMatchedList
          matchedList={recentList}
          onClick={() => console.log("cliked recent card")}
        />
      </Grid>{" "}
      <Grid size={{ lg: 4, md: 6, sm: 12, xs: 12 }}>
        <Typography
          fontSize={14}
          textTransform={"uppercase"}
          fontWeight={500}
          gutterBottom
        >
          Recent Logged in Users
        </Typography>
        <RecentLoggedInList
          loggedInUsers={recentLoggedList}
          onClick={() => console.log("cliked recent card")}
        />
      </Grid>
      <Grid size={{ lg: 8, md: 6, sm: 12, xs: 12 }}>
        <Typography
          fontSize={14}
          textTransform={"uppercase"}
          fontWeight={500}
          gutterBottom
        >
          Earnings
        </Typography>
      </Grid>
    </Grid>
  );
};

export default EmployeeDashboard;
